module.exports = __webpack_public_path__ + "img/kep2-2.1b3dcec2.jpg";